import { createSelector } from 'reselect';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import { GlobalState } from '../../reducers';
import { SwitchAppVersionState } from './reducers';
import constants from './constants';
import { records as rdsRecords } from '../realDeviceSelection';

const switchAppVersionSelector = (state: GlobalState): SwitchAppVersionState => (
  state.apps.manual.switchAppVersion
);

const filesModalSelector = createSelector([
  (state: GlobalState) => state.apps.manual.session,
  switchAppVersionSelector,
],
(currentSession, switchAppVersionState) => {
  const currentFile = currentSession.get('appVersion') as appStorageRecords.AppStorageFile;

  return {
    // TODO: remove once it's properly typed
    currentDevice: currentSession.get('deviceDescriptor') as rdsRecords.DeviceDescriptor | null,
    currentFile,
    files: switchAppVersionState.files.filter((file) => (
      (file.group_id === currentFile?.group_id) && !file.isSimulatorBuild()
    )),
    hasDataFetched: switchAppVersionState.hasDataFetched,
    isLoading: switchAppVersionState.isLoading,
    searchQuery: switchAppVersionState.searchQuery,
  };
});

const filesListPaginationSelector = createSelector([
  switchAppVersionSelector,
],
(switchAppVersionState) => ({
  currentPage: switchAppVersionState.currentPage,
  itemsPerPage: constants.FETCH_FILES_PAGE_SIZE,
  totalItems: switchAppVersionState.totalItems,
}));

export default {
  switchAppVersionSelector,
  filesListPaginationSelector,
  filesModalSelector,
};
